import { getLangByHtml } from '@ncui/util-js';

import {
  langType,
  countryType,
  IFooterConfig,
  IFooterConfigAllwithDefault,
  IChangeLanguage,
} from '../interface/IFooter';
import { footerL10n, footerL10nLang } from './L10n';

const DEFAULT_CONFIG: Required<IFooterConfig> = {
  countryList: [],
  languageList: [],
  languageCountryList: [],
  snsList: [],
  linkList: [],
  gameGrade: '',
  csInfoType: 'mobile',
  copyright: '',
  companyLink: '',
  keepPath: false,
  keepPathForLang: true,
  operationPolicyLink: '',
  communityPolicyLink: '',
  cookiePolicyLink: '',
  legalDocumentationLink: '',
  gameGradeLink: '',
  termsOfUseLink: '',
  familySiteList: [],
  isKakaoGamesChannel: false,
  isCsInfoNCV: false,
  isCsInfoNCA: false,
  isCsInfoHEROSE: false,
  isCsInfoNCA_bns: false,
  isCsInfoNCA_aion: false,
  isCsInfoNCA_lineage2: false,
  isCsInfoNCVVN: false,
  isCsInfoFirstSpark: false,
  isCsInfoBreakers: false,
};

export default class DataStore {
  private static _instance: DataStore;

  public lang!: langType;
  public langForL10n!: langType;
  public country!: countryType;
  public service!: string;
  public config!: IFooterConfig;
  public l10n!: FooterL10n;
  public l10nLang!: IChangeLanguage;
  public countryData!: Array<{ country: string; text: string }>;
  public geoCountry!: countryType;

  private constructor() {}

  public static get instance() {
    return this._instance || (this._instance = new this());
  }

  public init(_config: IFooterConfigAllwithDefault) {
    const htmlEl = document.querySelector('html');
    if (htmlEl) {
      // footer 에 들어가는 문구의 l10n을 위한 lang 값 (html lang값 es는 상황에 따라 es-mx, es-es 두개로 나뉘어 진다)
      this.langForL10n = this.getLangForL10n(); 

      // 이건, 그냥 진짜 html lang 값 가져오기. 
      // getLangByHtml 함수를 사용하는 것과는 별개이다. 

      // 이게 필요한 이유는 Language.ts에서 필요하기 때문이며(언어 선택만 있는것), 
      // 의외로 LanuageContry.ts에서도 사용한다. (언어/국가 선택 따로 하는것)
      // (this.ds.lang 으로 사용 중)

      // 애초에 언어, 국가가 분리되어 있던 초기에는 es-MX, ex-ES 등 뒤에 국가가 필요없이 es만 필요한 경우였다.
      // 물론 초기 설계가 좀 이상하긴 하다. es-MX, es-ES가 서로 다른 언어인데
      // lang 속성에 들어오는 es 만가지고 Language.ts에서 현재 선택된 언어가 무엇인지 파악하고 있으니, 
      // Language.ts 로는 es-ES, ex-MX 두개를 사용할수 없는 경우이다. 

      // 초기에는 언어는 es, 국가는 MX 를 선택하면 es-MX 가 출력되는 형식의 설계였다. (언어/국가 분리)
      // 하지만 사실 언어/국가를 분리해서 사용한다고 해도 lang값은 es-MX나 es-ES로 들어와야 하는게 맞을거 같고, 
      // 이후 국가선택은 운영정책을 위해 MX 든 ES 든 선택하게 했어야 했는데
      // 암튼 현재 우리는 lang값에는 lang 코드만 들어온다.

      // 여튼 현재로서는 lang값에 lang만 들어오니, ex-MX, ex-ES 를 구분할수 없다.
      // Language.ts를 위해 초기 구현된 부분을 위해 남겨두긴 하나, 
      // Language.ts가 사용되는 곳은 거의 없는거 같다. (언어/국가 선택 따로 하는것)

      // this.lang을 쓰고 있는 또다른 곳인 LanuageContry.ts도 lang 값과 country 값을 조합해서 쓰고 있는데
      // 이게 맞아? 
      this.lang = (htmlEl.getAttribute('lang') || 'ko') as langType; 
      this.country = (htmlEl.getAttribute('data-country') ||
        'KR') as countryType;
      this.service = htmlEl.getAttribute('data-service') || 'plaync';
      this.l10n = footerL10n[this.langForL10n];
      this.l10nLang = footerL10nLang; // 각 나라의 언어를 표현하는 문자를 각 나라의 언어로 표현한것
      this.config = this.setConfig(_config);
      this.countryData = this.sortCountry(this.config.countryList);
      for (var i in window) {
        if (i === '_geolocationCountry') {
          this.geoCountry = window[i] as unknown as countryType;
        }
      }
    }
  }

  setConfig(_config: IFooterConfigAllwithDefault): IFooterConfig {
    let defaultConfig: IFooterConfig = Object.assign(
      {},
      DEFAULT_CONFIG,
      _config.default
    );
    let currentConfig: IFooterConfig = _config[this.country];

    if (currentConfig) {
      Object.assign(defaultConfig, currentConfig);
    }

    return defaultConfig;
  }

  sortCountry(_countryList: Array<countryType>) {
    const countryL10n = _countryList.map((it) => {
      return {
        country: it,
        text: this.l10n.country[it],
      };
    });

    return countryL10n.sort((a, b) => a.text.localeCompare(b.text, this.lang));
  }

  getLangForL10n(): langType {
    return getLangByHtml({ defaultLang: 'en' });
  }
}
